"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var Row_vue_1 = __importDefault(require("../Layout/Row.vue"));
var Column_vue_1 = __importDefault(require("../Layout/Column.vue"));
var DeposeTransformateur_vue_1 = __importDefault(require("./DeposeTransformateur.vue"));
var SourceValueTransfo_1 = __importDefault(require("../../../Transformateur/Mixins/SourceValueTransfo"));
var SourceControlIteration_1 = __importDefault(require("../../Mixins/SourceControlIteration"));
exports.default = vue_1.default.extend({
    props: ['name'],
    mixins: [SourceValueTransfo_1.default, SourceControlIteration_1.default],
    components: { DeposeTransformateur: DeposeTransformateur_vue_1.default, HeRow: Row_vue_1.default, HeColumn: Column_vue_1.default },
    data: function () {
        var model = this.$root.$data;
        return {
            transfoIdSelected: null,
            internalReadOnly: model.readOnly,
            parsedValue: null,
            required: false
        };
    },
    mounted: function () {
        this.parsedValue = this.parseValue();
        if (this.parsedValue) {
            this.transfoIdSelected = this.parsedValue[0].besoinId;
        }
    },
    methods: {
        getOptions: function () {
            if (!this.parsedValue) {
                return null;
            }
            return this.parsedValue.map(function (transfo) {
                return {
                    id: transfo.besoinId,
                    text: "Num\u00E9ro de poste : " + transfo.numPoste + ", Type: " + transfo.type + ", Puissance: " + transfo.puissance + "kVA, TPC: " + (!transfo.tpc ? 'Non' : 'Oui')
                };
            });
        }
    },
    computed: {
        mandatoryFields: function () {
            if (!this.parsedValue) {
                return null;
            }
            var fields = [];
            for (var i = 0; i < this.parsedValue.length; i++) {
                fields.push(this.prefix + "." + i + ".plaqueSignalitique");
                fields.push(this.prefix + "." + i + ".etatGeneral");
            }
            return fields.join(',');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/SpecificComponents/DeposesTransformateur.vue
// module id = 211
// module chunks = 0